import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import Nav from './Nav';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post('http://localhost:5000/api/auth/forgot-password', { email });
      
      if (response.data.success) {
        setMessage(`Se ha enviado un enlace de recuperación a ${email}. Por favor revisa tu bandeja de entrada.`);
        setSubmitted(true);
      } else {
        setError(response.data.msg || 'Error al procesar la solicitud');
      }
    } catch (err) {
      console.error('Error:', err);
      setError(err.response?.data?.msg || 'Error al enviar el correo de recuperación');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Nav />
      <div className="forgot-page">
        <div className="forgot-card">
          {/* Icon */}
          <div className="forgot-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="#FF6600" strokeWidth="1.5" width="36" height="36">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
          </div>

          {!submitted ? (
            <>
              <h2 className="forgot-title">¿Olvidaste tu contraseña?</h2>
              <p className="forgot-subtitle">
                Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.
              </p>

              {error && <div style={{ color: '#ff4444', marginBottom: '1rem', padding: '0.5rem', background: 'rgba(255, 68, 68, 0.1)', borderRadius: '4px' }}>{error}</div>}

              <form onSubmit={handleSubmit} className="forgot-form">
                <div className="forgot-field">
                  <label className="forgot-label">Correo electrónico</label>
                  <input
                    className="forgot-input"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="nombre@ecoscience.com"
                    required
                    autoComplete="email"
                  />
                </div>

                <button type="submit" className="forgot-btn-submit" disabled={loading}>
                  {loading ? '...' : 'Enviar enlace de recuperación'}
                </button>
              </form>
            </>
          ) : (
            <div className="forgot-success">
              <div className="success-icon">✓</div>
              <h2 className="forgot-title">Enlace enviado</h2>
              <p className="forgot-subtitle">{message}</p>
              <p className="forgot-hint">Revisa tu bandeja de entrada y la carpeta de spam.</p>
            </div>
          )}

          <div className="forgot-back">
            <Link to="/login" className="forgot-back-link">
              ← Volver al inicio de sesión
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;